import api from './api'

import type { ScriptTemplate, ScriptUseResponse } from '@/models/scriptTemplates'

class ScriptTemplatesApiService {
  static getInstance(): ScriptTemplatesApiService {
    return this.instance || (this.instance = new this())
  }

  private static instance: ScriptTemplatesApiService

  private baseUrl = '/samples/scripts'

  private constructor() {
    // empty for linter
  }

  getScriptTemplates() {
    const url = this.baseUrl
    return api.get<ScriptTemplate[]>(url)
  }

  useScriptTemplate(id: string) {
    const url = `${this.baseUrl}/use`

    return api.post<ScriptUseResponse>(url, { id })
  }
}

export default ScriptTemplatesApiService.getInstance()
